import { Link } from "react-router-dom";
import { ScrollReveal } from "@/components/base/ScrollAnimations";

interface WingHeroProps {
  badge: string;
  title: string;
  subtitle: string;
  description: string;
  icon: string;
  iconBg: string;
}

export default function WingHero({
  badge,
  title,
  subtitle,
  description,
  icon,
  iconBg,
}: WingHeroProps) {
  return (
    <section className="relative min-h-[380px] md:min-h-[480px] lg:min-h-[560px] flex items-center justify-center overflow-hidden bg-tie-navy">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract textile fabric texture in deep navy and teal tones, woven threads pattern, modern corporate aesthetic, dark moody background with subtle warm highlights, no blue no purple, professional business atmosphere, horizontal composition"
          alt=""
          className="w-full h-full object-cover opacity-15"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-tie-navy/80 via-tie-navy/60 to-tie-navy/90" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 pt-24 pb-12 md:pb-16">
        <div className="max-w-4xl mx-auto text-center">
          <ScrollReveal>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 border border-white/20 mb-5 md:mb-6">
              <span className="text-xs md:text-sm text-white/80 font-medium tracking-wide uppercase">
                {badge}
              </span>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={100}>
            <div className="flex items-center justify-center gap-3 md:gap-4 mb-4 md:mb-5">
              <div className={`w-12 h-12 md:w-14 md:h-14 rounded-xl ${iconBg} flex items-center justify-center`}>
                <i className={`${icon} text-white text-xl md:text-2xl`} />
              </div>
              <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
                {title}
              </h1>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={200}>
            <p className="text-lg md:text-xl lg:text-2xl text-white/80 font-medium mb-3 md:mb-4">
              {subtitle}
            </p>
          </ScrollReveal>

          <ScrollReveal delay={300}>
            <p className="text-base md:text-lg text-white/60 max-w-3xl mx-auto leading-relaxed">
              {description}
            </p>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}